// Libraries
import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Components
import Modal from 'ui/Modal'
import Text from 'ui/Text'

// Icons
import IconFinger from 'ui/Icons/IconFinger'
import Row from 'ui/Row'
import Col from 'ui/Col'
import Button from 'ui/Button'
import Box from 'ui/Box'

function PopupExistMail({ onClickLogin, onClickResetPassword, ...props }) {
  const [visible, setVisible] = useState(true)

  return (
    <Modal show={visible} style={{ textAlign: 'center' }} {...props}>
      <Row noGutters>
        <Col xs={{ vcenter: true, span: 12 }}>
          <IconFinger />
        </Col>
        <Col xs={{ span: 12 }}>
          <Text size={20} bold color="#000" paddingTop={10} paddingBottom={10}>
            Password not saved
          </Text>
          <Text size={16} color="#000">
            We noticed that your email has already been registered to another
            Globe app (eg. GlobeONE or TM app).
          </Text>
          <Text size={16} color="#000" paddingBottom={30}>
            For your convenience, <strong>you may now access Paytrack</strong>{' '}
            using the same password set on your other Globe apps.
          </Text>
        </Col>
        <Col xs={{ span: 12, vcenter: true }}>
          <Button
            width="300px"
            onClick={() => {
              setVisible(false)
              onClickLogin()
            }}
          >
            Proceed to login
          </Button>
        </Col>
      </Row>
      <Box
        round={false}
        backgroundColor="#ECF4FC"
        style={{ padding: '10px', marginTop: 30 }}
      >
        <Text color="#000" size={15}>
          Already forgot your password from the other Globe apps?
        </Text>
        <Button
          variant="link"
          underline
          onClick={() => {
            setVisible(false)
            onClickResetPassword()
          }}
        >
          Reset your password
        </Button>
      </Box>
    </Modal>
  )
}

PopupExistMail.propTypes = {
  onClickLogin: PropTypes.func,
  onClickResetPassword: PropTypes.func,
}

PopupExistMail.defaultProps = {
  onClickLogin: () => {},
  onClickResetPassword: () => {},
}

export default PopupExistMail
